import { apiStaticUrlGet } from "common/api/api_common";
import {
  PHOTO_SIZE_TYPE,
  PhotoSizeType,
} from "constant/photo_series/photo_series.constant";
import ObjCommon from "model/common/ObjCommon";

export type PhotoTag = {
  top: number;
  left: number;
  imH: number;
  imW: number;
  val: string;
};

export class PhotoInfo extends ObjCommon {
  name: string = "";
  small: string = "";
  middle: string = "";
  desc: string = "";
  tag: PhotoTag[] = [];

  constructor(args: Partial<PhotoInfo> = {}) {
    super(args?.id);

    this.name = args?.name ?? "";
    this.small = args?.small ?? "";
    this.middle = args?.middle ?? "";
    this.desc = args?.desc ?? "";
    this.tag = args?.tag ?? [];
  }

  static photoInfosFromArray(data: Partial<PhotoInfo>[]): PhotoInfo[] {
    if (!data || data.length === 0) {
      return [];
    }
    return data.map((item) => new PhotoInfo(item));
  }

  getPhotoStaticUrl(fold: string, sizeType: PhotoSizeType): string {
    const photoTypeKey = sizeType !== PHOTO_SIZE_TYPE.LARGE ? sizeType : "name";
    const url = apiStaticUrlGet(`photo-series/${fold}/${this[photoTypeKey]}`);
    return url;
  }

  getAlt(): string {
    return this.name.replace(/[-_]/g, " ");
  }
}
